// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__XUQYF","transparent":"Backdrop_transparent__0tD9b"};